import { render, staticRenderFns } from "./DocumentNote.vue?vue&type=template&id=aaa05894&scoped=true"
import script from "./DocumentNote.vue?vue&type=script&lang=js"
export * from "./DocumentNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa05894",
  null
  
)

export default component.exports